import { COST_SIMULATION_YEARS } from "@repo/shared";

// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Cost Projection",
    titleHelp: "Optional heading to display above the cost chart",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and chart",
    displayMode: "Display Mode",
    displayModeHelp: "Choose how the cost projection timeline is displayed",
    rollingPeriods: "Rolling Periods (years from start)",
    calendarYears: "Calendar Years",
    chartType: "Chart Type",
    chartTypeHelp: "Choose how the cost projection is visualised",
    lineChart: "Line chart",
    barChart: "Bar chart",
    projectionYears: "Projection length (years)",
    projectionYearsHelp: `How many years of the cost projection to display (2-${COST_SIMULATION_YEARS})`,
    componentDescription:
      "This component displays the projected account value with and without investment costs over time, as a line chart or a stacked bar chart.",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Kostnadsprognose",
    titleHelp: "Valgfri overskrift som vises over kostnadsdiagrammet",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og diagrammet",
    displayMode: "Visningsmodus",
    displayModeHelp: "Velg hvordan kostnadsprognosen skal vises",
    rollingPeriods: "Rullerende perioder (år fra start)",
    calendarYears: "Kalenderår",
    chartType: "Diagramtype",
    chartTypeHelp: "Velg hvordan kostnadsprognosen skal visualiseres",
    lineChart: "Linjediagram",
    barChart: "Stolpediagram",
    projectionYears: "Framskrivningslengde (år)",
    projectionYearsHelp: `Hvor mange år av kostnadsframskrivningen som vises (2-${COST_SIMULATION_YEARS})`,
    componentDescription:
      "Denne komponenten viser forventet kontoverdi med og uten investeringskostnader over tid, som et linjediagram eller et stablet stolpediagram.",
  },
} as const;
